import React from "react";
import PropTypes from "prop-types";
import { useConfig, ModuleLoader } from "@eis-poc/lib-discover-medical-mfes";
import ErrorBoundary from "../ErrorBoundary";

function MfeWrapper({ name, onLoad, loadingElement, eventBus }) {
  const mfeContext = useConfig();
  if (!mfeContext?.mfes) {
    return <></>;
  }
  const mfeConfig = mfeContext.mfes[name];

  return (
    <ErrorBoundary team={mfeConfig?.team} component={mfeConfig.componentName}>
      <ModuleLoader
        containerName={mfeConfig.containerName}
        module={mfeConfig.module}
        remoteUrl={mfeConfig.remoteUrl}
        version={mfeConfig.versionId}
        onLoad={onLoad}
        fallback={loadingElement}
        eventBus={eventBus}
      />
    </ErrorBoundary>
  );
}

MfeWrapper.propTypes = {
  name: PropTypes.string,
  onLoad: PropTypes.func,
  eventBus: PropTypes.object.isRequired
};

export default MfeWrapper;
